import React, { useState } from "react";
import classes from "./SettingsPage.module.css";
import {
  FaArrowLeft,
  FaChevronRight,
  FaGlobe,
  FaRankingStar,
  FaShieldHalved,
  FaWallet,
} from "react-icons/fa6";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../store/slices/languageSlice";
import { languages } from "../utils/constants";

const SettingsPage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [showLanguageOptions, setShowLanguageOptions] = useState(false);

  const selectedLanguageId = Number(
    useSelector((state) => state?.persisted?.languageSlice?.language ?? 1),
  );

  const selectedLanguage =
    languages.find(
      (lang) => Number(lang.language_id) === Number(selectedLanguageId),
    ) || languages[0];

  const handleLanguageChange = (lang) => {
    dispatch(setLanguage(Number(lang.language_id)));
    i18n.changeLanguage(String(lang.language_id));
    setShowLanguageOptions(false);
  };

  return (
    <main className={classes.page}>
      <div className={classes.bgGlowOne}></div>
      <div className={classes.bgGlowTwo}></div>

      <section className={classes.category_section}>
        <div className={classes.category_topbar}>
          <motion.button
            type="button"
            className={classes.back_btn}
            onClick={() => navigate(-1)}
            whileHover={{ x: -3, scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
          >
            <FaArrowLeft />
          </motion.button>

          <div className={classes.category_heading_container}>
            <span className={classes.category_kicker}>{t("139")}</span>
          </div>
        </div>

        <section className={classes.container}>
          <div className={classes.settingsCard}>
            <div className={classes.languageBlock}>
              <button
                type="button"
                className={classes.settingItem}
                onClick={() => setShowLanguageOptions(!showLanguageOptions)}
              >
                <div className={classes.leftSection}>
                  <div className={classes.iconBox}>
                    <FaGlobe />
                  </div>

                  <div className={classes.textContent}>
                    <p className={classes.itemTitle}>{t("140")}</p>
                  </div>
                </div>

                <div className={classes.rightSection}>
                  <span className={classes.itemValue}>
                    {selectedLanguage.label}
                  </span>
                  <FaChevronRight
                    className={`${classes.arrowIcon} ${
                      showLanguageOptions ? classes.arrowOpen : ""
                    }`}
                  />
                </div>
              </button>

              {showLanguageOptions && (
                <div className={classes.languageOptions}>
                  {languages.map((lang) => (
                    <button
                      key={lang.language_id}
                      type="button"
                      className={`${classes.languageOption} ${
                        Number(lang.language_id) === selectedLanguageId
                          ? classes.languageOptionActive
                          : ""
                      }`}
                      onClick={() => handleLanguageChange(lang)}
                    >
                      <span>{lang.label}</span>
                      <span className={classes.languageShort}>
                        {lang.short}
                      </span>
                    </button>
                  ))}
                </div>
              )}
            </div>

            <button
              type="button"
              className={classes.settingItem}
              onClick={() => navigate("/profile")}
            >
              <div className={classes.leftSection}>
                <div className={classes.iconBox}>
                  <FaWallet />
                </div>

                <div className={classes.textContent}>
                  <p className={classes.itemTitle}>{t("141")}</p>
                </div>
              </div>

              <div className={classes.rightSection}>
                <FaChevronRight className={classes.arrowIcon} />
              </div>
            </button>
            {/*
            <button type="button" className={classes.settingItem}
              onClick={() => navigate("/my-games")}
            >
              <div className={classes.leftSection}>
                <div className={classes.iconBox}>
                  <FaRankingStar />
                </div>

                <div className={classes.textContent}>
                  <p className={classes.itemTitle}>{t("142")}</p>
                </div>
              </div>

              <div className={classes.rightSection}>
                <FaChevronRight className={classes.arrowIcon} />
              </div>
            </button>
*/}
            <button
              type="button"
              className={classes.settingItem}
              onClick={() => navigate("/privacy")}
            >
              <div className={classes.leftSection}>
                <div className={classes.iconBox}>
                  <FaShieldHalved />
                </div>

                <div className={classes.textContent}>
                  <p className={classes.itemTitle}>{t("143")}</p>
                </div>
              </div>

              <div className={classes.rightSection}>
                <FaChevronRight className={classes.arrowIcon} />
              </div>
            </button>
          </div>
        </section>
      </section>
    </main>
  );
};

export default SettingsPage;
